import React, {useEffect, useState} from "react";
import Field from "./Field";
import ModalPopup from "../widgets/ModalPopup";
import {AlternativeButton, DefaultButton} from "../widgets/Buttons";
import {validateAllFields, ValidationSuccess} from "../rules";


const isDebug = false

export const EditObservationPopup = ({dossier, observation, title, onSaveClick, onCancelClick, adatas, round, row}) => {

    const [fields, setFields] = useState(observation ? observation.fields: {})

    const [validationResults, setValidationResults] = useState(ValidationSuccess)

    const [errorMessage, setErrorMessage] = useState(null)

    useEffect(() => {
        setValidationResults(
            validateAllFields({
                dossier,
                round,
                row: {...row, adatas},
                fields
            })
        )
    },[])


    const renderFieldList = () => adatas.map(adata =>
        <Field
            dossier={dossier}
            currentRound={round}
            key={`adata-${adata.fieldName}`}
            fieldValues={fields}
            adata={adata}
            errorMessage={validationResults.errorMessages[adata.key]}
            onFieldEdit={(name, value) => {
                const nextFields = {...fields, [name]: value}

                const vr = validateAllFields({
                    dossier,
                    round,
                    row: {...row, adatas},
                    fields: nextFields
                })

                setValidationResults(vr)
                setFields(nextFields)
            }}
        />
    )

    return <ModalPopup
        marginTop={200}
        title={
            <>{title} <span>({round.visit_label} {round.visit_date})</span></>
        }
        onClose={onCancelClick}
        header={errorMessage}
        footer={<>
            <DefaultButton
                caption={"Save"}
                onClick={() => {

                    const vr = validateAllFields({
                        dossier,
                        round,
                        row: {...row, adatas},
                        fields
                    })

                    if(! vr.hasErrors) {
                        onSaveClick(fields)
                    }
                    else {
                        setValidationResults(vr)
                    }
                }}
            />
            <AlternativeButton
                caption={"Cancel"}
                onClick={onCancelClick}
            />
        </>}
    >
        {
            renderFieldList()
        }

        {
            isDebug ? <pre>
            {JSON.stringify(fields, null, 2)}
        </pre>: null
        }

    </ModalPopup>
}